import { useClientsStore } from '@/store/clients';
import { useUsersStore } from '@/store/users';
import { useProductsStore } from '@/store/products'
import { useOpportunitiesStore } from '@/store/opportunities';
import { useContactsStore } from '@/store/contacts';

export const salesOptions = {
    searchClientsAndLeads: async (query: string | Record<string, any> = '') => {
    const store = useClientsStore();
    await store.searchClientsAndLeads(query);
    return store.clients_leads;
  },
  searchUsers: async (query: string | Record<string, any> = '') => {
    const store = useUsersStore();
    await store.searchUsers(query);
    return store.users_result;
  },
  searchProducts: async (query: string | Record<string, any> = '') => {
    const store = useProductsStore();
    await store.fetchProducts(query);
    return store.products;
  },
  searchOpportunity: async (params = {}) => {
    const store = useOpportunitiesStore();
    await store.fetchOpportunities(params);
    return store.opportunities;
  },
  searchContacts: async (query: string | Record<string, any> = '') => {
    const store = useContactsStore();
    await store.searchContact(query);
    return store.contacts_result;
  },
  searchClients: async (query: string | Record<string, any> = '') => {
    const store = useClientsStore();
    await store.searchClients(query);// 'filter[tag]':'Agencia' });
    return store.clients_result;
  },
};
